import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface RecommendedProduct {
  id: string;
  name: string;
  image: string;
  price: number;
}
export const YouMayAlsoLike = () => {
  const carouselRef = useRef<HTMLDivElement>(null);
  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: -300,
        behavior: 'smooth'
      });
    }
  };
  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: 300,
        behavior: 'smooth'
      });
    }
  };
  const recommendedProducts: RecommendedProduct[] = [{
    id: 'galaxy-s22-ultra',
    name: 'Samsung Galaxy S22 Ultra (5G)',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6suz89Qq7Xie9KBvJcsjMU/image.png',
    price: 458.0
  }, {
    id: 'galaxy-s21',
    name: 'Samsung Galaxy S21',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/haCX8VrDURmHsvxeGczxzC/image.png',
    price: 288.0
  }, {
    id: 'galaxy-s22',
    name: 'Samsung Galaxy S22 (5G)',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9CLQER3mW4v2Jv4RPGHc1W/image.png',
    price: 308.0
  }, {
    id: 'galaxy-s21-ultra',
    name: 'Samsung Galaxy S21 Ultra (5G)',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/umiFkcmrpPKvt7dyWTcHiw/image.png',
    price: 358.0
  }, {
    id: 'galaxy-s22-plus',
    name: 'Samsung Galaxy S22+ (5G)',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/umiFkcmrpPKvt7dyWTcHiw/image.png',
    price: 338.0
  }];
  return <section className="py-10 border-t border-gray-200" data-id="element-1369">
      <div className="container mx-auto px-4" data-id="element-1370">
        <div className="flex justify-between items-center mb-6" data-id="element-1371">
          <h2 className="text-2xl font-bold text-gray-800" data-id="element-1372">
            You May Also Like
          </h2>
          <Link to="/products" className="text-blue-600 hover:underline font-medium" data-id="element-1373">
            View all
          </Link>
        </div>
        <div className="relative" data-id="element-1374">
          <button onClick={scrollLeft} className="absolute left-0 top-1/2 -translate-y-1/2 -ml-4 z-10 bg-white rounded-full shadow-md p-2 hover:bg-gray-100" aria-label="Scroll left" data-id="element-1375">
            <ChevronLeftIcon className="h-6 w-6 text-gray-600" data-id="element-1376" />
          </button>
          <div ref={carouselRef} className="flex overflow-x-auto pb-6 hide-scrollbar gap-6" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-1377">
            {recommendedProducts.map(product => <div key={product.id} className="min-w-[220px] bg-white rounded-lg overflow-hidden hover:shadow-md transition-all duration-200 transform hover:scale-105" data-id="element-1378">
                <Link to={`/product/${product.id}`} data-id="element-1379">
                  <div className="p-4" data-id="element-1380">
                    <div className="h-40 flex items-center justify-center mb-4" data-id="element-1381">
                      <img src={product.image} alt={product.name} className="h-full object-contain" data-id="element-1382" />
                    </div>
                    <h3 className="text-sm font-medium text-gray-800 mb-1" data-id="element-1383">
                      {product.name}
                    </h3>
                    <div className="text-blue-600 font-medium" data-id="element-1384">
                      From SGD {product.price.toFixed(2)}
                    </div>
                  </div>
                </Link>
              </div>)}
          </div>
          <button onClick={scrollRight} className="absolute right-0 top-1/2 -translate-y-1/2 -mr-4 z-10 bg-white rounded-full shadow-md p-2 hover:bg-gray-100" aria-label="Scroll right" data-id="element-1385">
            <ChevronRightIcon className="h-6 w-6 text-gray-600" data-id="element-1386" />
          </button>
        </div>
      </div>
      <style jsx data-id="element-1387">{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </section>;
};